<div>
  <sc-title>
    <sc-dictionary-label dictionaryKey="tmc-yard.ui.transport.attach-detach.dialog.step.title.select-action"></sc-dictionary-label>
  </sc-title>
  <sc-content-spacer vertical></sc-content-spacer>
  <div class="warning" *ngIf="stepperModel.workingData.warningDictionaryKey">
    <sc-dictionary-label dictionaryKey="Warning! transport is not assigned to processing position!"></sc-dictionary-label>
  </div>
  <sc-content-spacer vertical [double]="true"></sc-content-spacer>
  <mat-radio-group [(ngModel)]="selectedAction">
    <sc-flex stretchContent>
      <sc-flex-fitting-content>
        <sc-sub-title>
          <sc-dictionary-label dictionaryKey="tmc-yard.ui.transport.attach-detach.dialog.label.detach"></sc-dictionary-label>
        </sc-sub-title>
        <sc-content-spacer vertical></sc-content-spacer>
        <div>
          <mat-radio-button class="padding-bottom-10" value="{{actions.DETACH_TRUCK}}"
            [disabled]="isDetachTruckDisabled()">
            <sc-dictionary-label dictionaryKey="tmc-yard.ui.transport.attach-detach.dialog.option.detachTruck"></sc-dictionary-label>
          </mat-radio-button>
        </div>
        <div>
          <mat-radio-button class="padding-bottom-10" value="{{actions.DETACH_TRUCK_AND_TRAILER}}"
            [disabled]="isDetachTruckAndTrailerDisabled()" *ngIf="swapTrailerEnabled()">
            <sc-dictionary-label dictionaryKey="tmc-yard.ui.transport.attach-detach.dialog.option.detachTruckAndTrailer"></sc-dictionary-label>
          </mat-radio-button>
        </div>
        <div>
          <mat-radio-button class="padding-bottom-10" value="{{actions.DETACH_TRAILER}}"
            [disabled]="isDetachTrailerDisabled()" *ngIf="swapTrailerEnabled()">
            <sc-dictionary-label dictionaryKey="tmc-yard.ui.transport.attach-detach.dialog.option.detachTrailer"></sc-dictionary-label>
          </mat-radio-button>
        </div>
        <div>
          <mat-radio-button class="padding-bottom-10" value="{{actions.DETACH_TRAILER_SEMI_TRAILER_TRUCK}}"
            [disabled]="isDetachTrailerSemiTrailerTruckDisabled()">
            <sc-dictionary-label dictionaryKey="tmc-yard.ui.transport.attach-detach.dialog.option.detachTrailerSemiTrailerTruck"></sc-dictionary-label>
          </mat-radio-button>
        </div>
      </sc-flex-fitting-content>
      <sc-content-spacer></sc-content-spacer>
      <sc-flex-fitting-content>
        <sc-sub-title>
          <sc-dictionary-label dictionaryKey="tmc-yard.ui.transport.attach-detach.dialog.label.attach"></sc-dictionary-label>
        </sc-sub-title>
        <sc-content-spacer vertical></sc-content-spacer>
        <div>
          <mat-radio-button class="padding-bottom-10" value="{{actions.ATTACH_TRUCK}}"
            [disabled]="isAttachTruckDisabled()">
            <sc-dictionary-label dictionaryKey="tmc-yard.ui.transport.attach-detach.dialog.option.attachTruck"></sc-dictionary-label>
          </mat-radio-button>
        </div>
        <div>
          <mat-radio-button class="padding-bottom-10" value="{{actions.ATTACH_TRAILER}}"
            [disabled]="isAttachTrailerDisabled()" *ngIf="swapTrailerEnabled()">
            <sc-dictionary-label dictionaryKey="tmc-yard.ui.transport.attach-detach.dialog.option.attachTrailer"></sc-dictionary-label>
          </mat-radio-button>
        </div>
        <sc-content-spacer vertical></sc-content-spacer>
        <sc-sub-title>
          <sc-dictionary-label dictionaryKey="tmc-yard.ui.transport.attach-detach.dialog.label.swap-trailer"></sc-dictionary-label>
        </sc-sub-title>
        <sc-content-spacer vertical></sc-content-spacer>
        <div>
          <mat-radio-button class="padding-bottom-10" value="{{actions.TRAILER_SWAP}}"
            [disabled]="isTrailerSwapDisabled()">
            <sc-dictionary-label dictionaryKey="tmc-yard.ui.transport.attach-detach.dialog.option.swap-trailer"></sc-dictionary-label>
          </mat-radio-button>
        </div>
      </sc-flex-fitting-content>
    </sc-flex>
  </mat-radio-group>
</div>
